/**
 * Búsqueda por palabras sueltas.
 *
 * Buscar la frase completa falla apenas el nombre trae algo en el medio, que es
 * lo normal en nombres largos ("TARTA CHOCLO Y ZAPALLO SALUTE" no aparecía
 * buscando "tarta zapallo"). Acá cada palabra tiene que estar en ALGUNO de los
 * campos, en cualquier orden y sin necesidad de estar juntas.
 */
export function matchesAllWords(query: string, ...campos: (string | null | undefined)[]): boolean {
  const palabras = query.trim().toLowerCase().split(/\s+/).filter(Boolean);
  if (palabras.length === 0) return true;
  const texto = campos.filter(Boolean).join(' ').toLowerCase();
  return palabras.every((p) => texto.includes(p));
}
